import React, { useEffect, useRef, useState } from 'react';
import { Calendar } from 'react-multi-date-picker';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterDataState } from '../../../modules/filter/filterAction';
import { Avatar, Box, Grid, Tooltip } from '@mui/material';
import { MAIN_BLUE } from '../../../color';
import {
  SHOW_NOTIFICATION,
  wfhCalenderHighlightColor,
} from '../../../constants';
import { getLeaveTypeForUser } from '../../../services/UserService';
import moment from 'moment';

function CalenderViewComponent(props) {
  const { type, data } = props;

  const dispatch = useDispatch();
  const calendarRef = useRef();
  const gridRef = useRef();
  const state = useSelector((state) => state.filterState);
  const [dateClicked, setDateClicked] = useState(new Date());
  const [leaveType, setLeaveType] = useState([]);
  const [gridWidth, setGridWidth] = useState(window.innerWidth);
  const [numberOfItemPerRow, setNumberOfItemPerRow] = useState(0);
  const [isFixed, setIsFixed] = useState(false);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getLeaveTypeList = async () => {
    const response = await getLeaveTypeForUser(dateClicked.getFullYear());
    if (response.isError === false) {
      if (response.data !== undefined) {
        setLeaveType(response.data);
      }
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
  };

  const calenderDesignChange = (itemCount) => {
    const calenderDayPicker =
      calendarRef?.current?.querySelectorAll('.rmdp-day-picker');

    if (
      calenderDayPicker &&
      calenderDayPicker[0] &&
      calenderDayPicker[0].children
    ) {
      let monthBoxList = calenderDayPicker[0].children;
      calenderDayPicker[0].style.gridTemplateColumns = Array(itemCount)
        .fill('1fr')
        .join(' ');
      for (let i = 0; i < monthBoxList.length; i++) {
        if (i < itemCount * (12 / itemCount - 1)) {
          if (i % itemCount < itemCount - 1) {
            monthBoxList[i].style.borderColor = 'black';
            monthBoxList[i].style.borderStyle = 'solid';
            monthBoxList[i].style.borderWidth = '1px 0px 0px 1px';
            monthBoxList[i].style.marginRight = '0px';
          } else {
            monthBoxList[i].style.borderColor = 'black';
            monthBoxList[i].style.borderStyle = 'solid';
            monthBoxList[i].style.borderWidth = '1px 1px 0px 1px';
            monthBoxList[i].style.marginRight = '0px';
          }
        } else {
          if (i % itemCount < itemCount - 1) {
            monthBoxList[i].style.borderColor = 'black';
            monthBoxList[i].style.borderStyle = 'solid';
            monthBoxList[i].style.borderWidth = '1px 0px 1px 1px';
            monthBoxList[i].style.marginRight = '0px';
          } else {
            monthBoxList[i].style.borderColor = 'black';
            monthBoxList[i].style.borderStyle = 'solid';
            monthBoxList[i].style.borderWidth = '1px 1px 1px 1px';
            monthBoxList[i].style.marginRight = '0px';
          }
        }
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 118) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    const resizeObserver = new ResizeObserver((entries) => {
      setGridWidth(entries[0].target.clientWidth);
    });

    if (gridRef.current) {
      resizeObserver.observe(gridRef.current);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (gridWidth > 1250) {
      setNumberOfItemPerRow(4);
    } else if (gridWidth > 900) {
      setNumberOfItemPerRow(3);
    } else if (gridWidth > 600) {
      setNumberOfItemPerRow(2);
    } else {
      setNumberOfItemPerRow(1);
    }
  }, [gridWidth]);

  useEffect(() => {
    calenderDesignChange(numberOfItemPerRow);
  }, [numberOfItemPerRow]);

  useEffect(() => {
    if (state?.startDate) {
      setDateClicked(new Date(state.startDate));
    }
    if (type !== 'wfh') {
      getLeaveTypeList();
    }
  }, [state]);

  const divFixedStyle = {
    position: isFixed ? 'fixed' : 'absolute',
    top: isFixed ? '70px' : '',
    width: '15rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const divStyle = {
    backgroundColor: MAIN_BLUE,
    textAlign: 'center',
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    marginLeft:
      gridWidth > 1250
        ? '70px'
        : gridWidth > 900
        ? '60px'
        : gridWidth > 600
        ? '55px'
        : '45px',
    marginRight: '10px',
  };

  const chipDivStyle = {
    textAlign: 'center',
    padding: '10px',
    width: '75%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    marginLeft: '30px',
  };

  const h3Style = {
    color: 'white',
    fontSize: '16px',
    margin: '2px',
  };

  const getColorCodeFromLeaveId = (id) => {
    for (let i = 0; i < leaveType.length; i++) {
      const label = leaveType[i];
      if (label.id === id) return label.color;
    }
  };

  const getLeaveNameFromLeaveId = (id) => {
    for (let i = 0; i < leaveType.length; i++) {
      const label = leaveType[i];
      if (label.id === id) return label.leaveName;
    }
  };

  return (
    <>
      <Grid ref={gridRef} container>
        <Grid item md={10} sm={8} xs={8}>
          <Calendar
            fullYear
            ref={calendarRef}
            highlightToday
            onFocusedDateChange={(dateFocused, dateClicked) => {
              dispatch(
                setFilterDataState({
                  ...state,
                  startDate: dateClicked.toString().split('/').join('-'),
                  endDate: dateClicked.toString().split('/').join('-'),
                }),
              );
            }}
            mapDays={() => calenderDesignChange(numberOfItemPerRow)}
          />
        </Grid>
        <Grid item md={2} sm={4} xs={4} container justifyContent="center">
          <div style={divFixedStyle}>
            <div style={divStyle}>
              <h3 style={h3Style}>
                {moment(dateClicked).format('Do MMM YYYY')}
              </h3>
            </div>
            <div style={chipDivStyle}>
              {data
                ? data.map((dat, index) => {
                    return (
                      <>
                        <Grid
                          key={index}
                          container
                          style={{
                            backgroundColor:
                              dat.type === 'WFH'
                                ? wfhCalenderHighlightColor
                                : getColorCodeFromLeaveId(dat.leaveId),
                            borderRadius: '20px',
                            maxWidth: '100%',
                            marginBottom: '10px',
                            color: 'white',
                          }}
                        >
                          <Tooltip
                            title={
                              dat.leaveId
                                ? getLeaveNameFromLeaveId(dat.leaveId)
                                : 'WFH'
                            }
                          >
                            <Grid
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'left',
                                overflow: 'hidden',
                                padding: '5px',
                              }}
                            >
                              <Avatar
                                style={{ marginRight: '8px' }}
                                alt={dat.empName}
                                src={dat.photo}
                                sx={{ width: 20, height: 20 }}
                              />
                              <div
                                style={{
                                  maxWidth: '100%',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <Box
                                  component="div"
                                  sx={{
                                    fontSize: '14px',
                                  }}
                                >
                                  {dat.empName}
                                </Box>
                              </div>
                            </Grid>
                          </Tooltip>
                        </Grid>
                      </>
                    );
                  })
                : ''}
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default CalenderViewComponent;
